import moment from 'moment';
import { DayOfWeek } from '../enums';

export class FindTimeModel{
    CustomerID:number;
    ExpertiesID: string;
    BranchID:string;
    SchedulerIDForUser:string;
    SchedulerIDForRoom:string;
    WeekDays:boolean[];
    Date: moment.Moment;
    ToDate: moment.Moment; // used when finding time for waitlistItem
    StartTime:string;
    EndTime:string;
    Duration:number;
    FirstDayOfWeek:DayOfWeek;    
    TreatmentID: string; // can be 1 or 1,2,3,4...
    PriceListRefIds: string // can be 1 or 1,2,3,4...
    

    constructor(obj?: any) {
        this.CustomerID = obj && obj.CustomerID || null; 
        this.ExpertiesID = obj && obj.ExpertiesID || null;
        this.BranchID = obj && obj.BranchID || null;
        this.SchedulerIDForUser = obj && obj.SchedulerIDForUser || null;
        this.SchedulerIDForRoom = obj && obj.SchedulerIDForRoom || null;
        this.WeekDays = obj && obj.WeekDays || [true, true, true, true, true, true, true];
        this.Date = obj && obj.Date && moment(obj.Date) || null;
        this.ToDate = obj && obj.Date && moment(obj.ToDate) || null;
        this.StartTime = obj && obj.StartTime || null;
        this.EndTime = obj && obj.EndTime || null;
        this.Duration = obj && obj.Duration || null;
        this.FirstDayOfWeek = obj && obj.FirstDayOfWeek || null;        
        this.TreatmentID = obj && obj.TreatmentID || null;
        this.PriceListRefIds = obj && obj.PriceListRefIds || null;
    }
}
